import { React, useEffect } from 'react';
import "../index.css";
import Sections from "../components/sections";


//MUI
import { Box, Container, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';

//Images and Media
import banner from '../assets/images/banner.jpg'
import managing_director from '../assets/images/anish_shah.jpg'



const BRSR = () => {
    useEffect(() => {
        const bannerText = document.getElementById('banner-animate');
        setTimeout(() => {
            bannerText.classList.add("active");
        }, 1000);
    }, []);

    return (
        <Box>
            <div className="banner-container">
                <img src={banner} alt='Banner' />
                <Box className="caption" pt={18}>
                    <Box id="banner-animate" className="content">
                        <Typography className="heading" variant='h4' sx={{ color: "#ffffff", fontSize: { xs: '24px', md: '32px' }, fontWeight: 'bold', textAlign: 'left' }}>
                            <span className="heading" style={{ color: '#e31837', fontSize: '36px' }}>B</span>usiness<br />
                            <span className="heading" style={{ color: '#e31837', fontSize: '36px' }}>R</span>esponsibility &<br />
                            <span className="heading" style={{ color: '#e31837', fontSize: '36px' }}>S</span>ustainability<br />
                            <span className="heading" style={{ color: '#e31837', fontSize: '36px' }}>R</span>eport<br />
                        </Typography>
                    </Box>
                </Box>
            </div>
            <Box px={{ xs: 5, xl: 30 }} py={8} sx={{ backgroundColor: "#e6e7e8" }}>
                <Grid container spacing={3} alignItems="center">
                    <Grid item xs={12} sm={6} lg={4}>
                        <Box ml={{ lg: 3 }} >
                            <img className='border-style' src={managing_director} height="400" alt="MD_image" />
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={8}>
                        <Box>
                            <Box mb={1}>
                                <Typography className="heading" variant='h5' sx={{ color: "#e31837", fontWeight: 'bold' }}>
                                    Message from the Group CEO and MD
                                </Typography>
                            </Box>
                            <Box mb={2} sx={{ maxHeight: 310, overflowY: "scroll" }} className="scroll">
                                <Typography variant='body1' sx={{ textAlign: "justify", marginRight: '20px' }}>
                                    Sustainability & climate action are central to Mahindra Group’s long-term vision, and our endeavour is to embed them into core business strategy. We believe that progress must be accompanied by environmental responsibility and societal well-being. Our ESG commitments are rooted in 3 pillars being planet positive (Environment), people positive (Social), and trust positive (Governance).
                                    <br /><br />
                                    Guided by 'Planet Positive' strategy, Mahindra businesses are progressing to reduce our operational environmental impact, decarbonizing the industries we operate in, focusing on climate adaptation & just transition, and advancing our ESG leadership and climate advocacy actions. During the year, we made progress in energy transition by accelerating energy efficiency measures, renewable energy adoption, and electrification. Beyond emissions, we advanced our work on water positivity, waste management, and material circularity.
                                    <br /><br />
                                    On the Social front, our commitment is anchored in our core philosophy of "Rise," driving positive change for our employees, partners, and communities. We are actively shaping a future-ready, diverse, and inclusive workforce and investing in upskilling programs to prepare our people for the electric vehicle transition. We continue to invest in safety in operations & supply chain particularly in fire safety.
                                    <br /><br />
                                    Through our "Rise for Good" initiatives, we continue to empower rural communities, foster girl-child education (through our flagship CSR programs namely Nanhi Kali and Kaabil), and ensure an equitable, just transition for our entire ecosystem as we move toward cleaner mobility solutions.
                                    <br /><br />
                                    On governance, our framework is anchored on the pillars of integrity, transparency, responsibility, and accountability. Through rigorous ESG disclosures, ethical supply chain practices, responsible board oversight, and stakeholder engagement, we are moving forward.
                                </Typography>
                            </Box>
                            <Box display="flex" justifyContent="space-between">
                                <Box>
                                    <Typography variant="h6" sx={{ color: "#e31837" }}>
                                        Dr. Anish Shah
                                    </Typography>
                                    <Typography>
                                        Group CEO and Managing Director, Mahindra Group
                                    </Typography>
                                </Box>
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
            </Box>
            <Container>
                <Box my={4}>
                    <Typography mt={7} className="heading" variant='h4' gutterBottom sx={{ color: "#e31837", fontWeight: 'bold' }}>
                        BRSR Report
                    </Typography>
                </Box>
                <Box mb={5}>
                    <Sections />
                </Box>
            </Container>
        </Box>
    )
}

export default BRSR;
